import { render, staticRenderFns } from "./create-v2.vue?vue&type=template&id=33de9ffc&scoped=true&"
import script from "./create-v2.vue?vue&type=script&lang=js&"
export * from "./create-v2.vue?vue&type=script&lang=js&"
import style0 from "./create-v2.vue?vue&type=style&index=0&id=33de9ffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de9ffc",
  null
  
)

export default component.exports